<template>
  <div class="dfw-home">
    <Announcement v-show="homeAnnouncementList.length > 0" @setMainContent="setMainContent"></Announcement>
    <Quick @itemClick="itemClick" :cmsConfig="cmsConfig" />
    <div class="home-top-warp">
      <!-- <img class='home-banner' :src="$viewImage(cmsConfig.banner.image)" v-if="cmsConfig.banner"> -->
      <div class="home-code-warp">
        <div class="home-code">
          <div class="home-code-inner">
            <dropdown-list @storeSelected="onStoreSelected"></dropdown-list>
            <Input
              class="code-input"
              @change="changeCode"
              placeholder="请输入券消费码"
            />
            <Button type="primary" class="code-bt" @click="searchBarcode"
              >查询</Button
            >
          </div>
          <p class="verify-history">
            <a @click="itemClick('//ygj.haiziwang.com/order/vcodelist.html')"
              >查看验证历史</a
            >
          </p>
        </div>
      </div>
      <OrderList
        :code="barcode"
        :list="orders"
        v-if="showOrder"
        :storeInfo="storeInfo"
        :useStore="useStore"
      />
    </div>
    <CommonPanel title="门店经营数据">
      <Trade :stData="cmsConfig.stData" />
    </CommonPanel>
    <CommonPanel title="用户评价" needExtra>
      <template slot="extra">
        <a
          @click="itemClick('//ygj.haiziwang.com/comment/business.html')"
          class="extra-item"
          >查看详情</a
        >
      </template>
      <a-row v-if="showPie">
        <a-col span="8"
          ><Pie
            class="pie-chart"
            :showLegend="false"
            :title="COMMENT[1].name"
            :subtext="`${commentData[COMMENT[1].key] || 0}`"
            :text="COMMENT[1].subText"
            :pieData="buildPieData(1)"
            :color="COMMENT[1].color"
        /></a-col>
        <a-col span="8"
          ><Pie
            class="pie-chart"
            :showLegend="false"
            :title="COMMENT[2].name"
            :subtext="`${commentData[COMMENT[2].key] || 0}`"
            :text="COMMENT[2].subText"
            :pieData="buildPieData(2)"
            :color="COMMENT[2].color"
        /></a-col>
        <a-col span="8"
          ><Pie
            class="pie-chart"
            :showLegend="false"
            :title="COMMENT[3].name"
            :subtext="`${commentData[COMMENT[3].key] || 0}`"
            :text="COMMENT[3].subText"
            :pieData="buildPieData(3)"
            :color="COMMENT[3].color"
        /></a-col>
      </a-row>
    </CommonPanel>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Row, Col, Input, Button, message, notification } from "ant-design-vue";
import CommonPanel from "@/components/common-panel/index";
import Pie from "@/components/pie";
import host from "@/utils/host";
import Trade from "./components/trade";
import OrderList from "./components/orderList";
import Quick from "./components/quick";
import DropdownList from "./components/dropdownList.vue";
import { queryBarcodeState } from "./services";
import _ from "lodash";
import { MIN_SAFE_INTEGER } from "./constants";
import Announcement from '../common/announceInfo/newAnnounce';
export default {
  name: "big-service-home",
  data() {
    return {
      commentData: {},
      showPie: false,
      COMMENT: {
        1: {
          key: "good",
          name: "好评",
          color: ["#59A7FF", "#f8f8f8"],
          subText: 0
        },
        2: {
          key: "medium",
          name: "中评",
          color: ["#FFB000", "#f8f8f8"],
          subText: 0
        },
        3: {
          key: "bad",
          name: "差评",
          color: ["#7ED321", "#f8f8f8"],
          subText: 0
        }
      },
      barcode: "",
      showOrder: false,
      orders: [],
      /**@type import('./services').storeInfo*/
      storeInfo: null,
      useStore: false
    };
  },
  async created() {
    // this.$store.dispatch('dfwHome/getUnreadMsgCount', {
    //   customerId: this.$cookie.get('buzzId')
    // })
    this.commentData = await this.$store.dispatch("dfwHome/getComment", {
      object_id: this.$cookie.get("buzzId"),
      type: 1
    });
    this.showPie = true;
  },
  methods: {
    setMainContent(component) {
      this.$emit('setMainContent', component)
    },
    /**
     * @param {{storeInfo:import('./services').storeInfo, useStore:boolean}}
     */
    onStoreSelected({ storeInfo, useStore }) {
      this.storeInfo = storeInfo;
      this.useStore = useStore;
    },
    changeCode(e) {
      // console.log(e)
      this.barcode = e.target.value;
    },
    async searchBarcode() {
      if (this.useStore && !this.storeInfo) {
        message.info("请选择门店");
        return;
      }
      if (!this.barcode) {
        message.info("请输入核销码");
        return;
      }
      // 先隐藏，注销orderList实例，再重新实例化，因为orderList 注销某个消费码之后disable=true,动态侦听并做响应动作比较繁琐，还不如注销后重新实例化组件
      this.showOrder = false

      // const json = await this.$store.dispatch("dfwHome/getBarCode", {
      //   barcode: this.barcode,
      // });
      const json = await queryBarcodeState(this.barcode);
      if (json && json.code * 1 === 1) {
        const res = json.data;
        let orders = [res];
        let bool = true;
        let str = "";
        const { storeInfo, useStore } = this;

        // console.log(json)
        if (+res.barcodeState === 1) {
          str = "该消费码已经被核销";
          orders = [];
          bool = false;
        } else if (useStore) {
          // 点击查询时，校验该核销码是否可在当前选择的门店核销；若可以，显示出订单信息及确认消费按钮
          if (res.storeList === null) {
            // 虽然是必须选择门店，但是成长加核销商品会存在无门店的情况，需要特殊处理
            if (storeInfo.businessId !== MIN_SAFE_INTEGER) {
              str = "该门店未查询到该核销码，请不选择门店重新查询";
              orders = [];
              bool = false;
            }
          } else if (
            _.isArray(res.storeList) &&
            !res.storeList.find(x => +x.storeId === +storeInfo.storeId)
          ) {
            str = "该商品不适用该核销门店，无法核销！";
            if (res.storeList.length > 0) {
              str += "该商品适用门店为";
              res.storeList.forEach(x => {
                str += x.storeName + "、";
              });
              str = str.substr(0, str.length - 1);
            }
            orders = [];
            bool = false;
          }
        }
        if (str) {
          notification.destroy();
          notification.info({
            message: "提示",
            description: str,
            duration: 0
          });
        }
        this.orders = orders;
        this.showOrder = bool;
      } else {
        message.info(json.msg);
      }
    },
    buildPieData(key) {
      const dd = this.COMMENT[key];
      if (dd) {
        const percent =
          this.commentData["commentNum"] > 0
            ? this.commentData[dd.key] / this.commentData["commentNum"]
            : 0;
        // console.log(percent.toFixed(4), (percent.toFixed(4)/0.01).toFixed(2))
        this.COMMENT[key].subText = `（占比${(
          percent.toFixed(4) / 0.01
        ).toFixed(2)}%）`;
        return [
          { value: percent, name: dd.title },
          { value: 1 - percent, name: "其他" }
        ];
      }
      return [
        { value: 0, name: "" },
        { value: 1, name: "其他" }
      ];
    },
    itemClick(link) {
      this.$emit("itemClick", link);
    },
    moreLinkHandler() {
      this.$emit(
        "itemClick",
        `${host.scm}/partners-scm-web/notice/noticeIndex.jsp?module=1`
      );
    }
  },
  computed: {
    ...mapState(["cmsConfig", "homeAnnouncementList"]),
    moreLink() {
      return `${host.scm}/partners-scm-web/notice/noticeIndex.jsp?module=1`;
    }
  },
  components: {
    Quick,
    CommonPanel,
    Input,
    Button,
    [Row.name]: Row,
    [Col.name]: Col,
    Trade,
    Pie,
    OrderList,
    DropdownList,
    Announcement
  }
};
</script>
<style lang="scss" scoped>
.dfw-home .common-panel-container {
  margin-bottom: 15px;
}
.dfw-home {
  // display: flex;
  // flex-direction: column;
  max-width: none;
  .home-top-warp {
    background: #fff;
    padding: 20px;
    margin-bottom: 15px;
  }
  .home-code-warp {
    max-width: none;
    margin-top: 20px;
    display: flex;
    justify-content: initial;
    padding-left: 180px;
    .home-code {
      width: auto;
    }
    .home-code-inner {
      display: flex;
      align-items: center;
      height: 50px;

      input::-webkit-input-placeholder {
        font-size: 18px;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        font-size: 18px;
      }
    }

    .verify-history {
      text-align: right;
      padding-right: 22px;
      font-size: 14px;
      color: $color-text-blue;
      padding-top: 10px;

      a {
        text-decoration: underline;
      }
    }
    .code-input {
      width: 440px;
      height: 50px;
      border: 1px solid $color-e2;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      color: #333;
      font-size: 18px;
    }
    .code-bt {
      width: 129px;
      height: 50px;
      border-radius: 2px;
      font-size: 18px;
      color: #ffffff;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      box-shadow: unset;
      text-shadow: unset;
    }
  }

  .pie-chart {
    width: 100%;
    height: 220px;
  }

  .extra-item {
    color: $primary-main !important;
    text-decoration: underline;
  }
}
</style>
